// Ported from design/project/App22b-ChallengeTaken.dc.html and App22c-ChallengeExpired.dc.html, then wired: the
// challenge link was opened too late. Both offer the player their own challenge on the same terms.
import { arenaLabel, otherSide } from "../challenge.js";
import { useGame } from "../game.js";
import { go } from "../router.js";
import { CHALLENGE_SIDE } from "./App21-ChallengeFriend.js";
import { seenChallenge } from "./App22-IncomingChallenge.js";

function TooLate({ title, body }: { title: string; body: (name: JSX.Element, arena: string) => JSX.Element }) {
  const { select } = useGame();
  const c = seenChallenge();
  const name = c?.creator.name ?? "player";
  const initials = name.replace(/^@/, "").slice(0, 2).toUpperCase();
  const challengeBack = () => {
    if (c) {
      // Their terms, the other side of their call: the side this player would have taken.
      select({ arena: c.arena, stake: c.stake.replace(/\.0+$/, ""), custom: !["2", "10", "50", "250"].includes(c.stake.replace(/\.0+$/, "")), durationSec: c.durationSec === 60 ? 60 : 180 });
      sessionStorage.setItem(CHALLENGE_SIDE, otherSide(c.side));
    }
    go("App21", true);
  };
  return (
    <>
      <div className="screen">
  <div className="orbL" aria-hidden="true" style={{ top: "120px", left: "-45px", width: "480px", height: "480px" }}></div>
  <div className="pad squeeze" style={{ height: "100%", paddingBottom: "calc(var(--dd-safe-bottom) + 8px)", boxSizing: "border-box", display: "flex", flexDirection: "column" }}>
    <div className="top" style={{ justifyContent: "center" }}><span className="chip" style={{ background: "rgba(255,255,255,0.08)", color: "#8B949E" }}>FROM A CHAT LINK</span></div>
    <div style={{ marginTop: "40px", alignSelf: "center", width: "96px", height: "96px", borderRadius: "26px", background: c?.side === "long" ? "#CCFF00" : "#FF3366", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Syne, sans-serif", fontWeight: "800", fontSize: "22px", letterSpacing: "-0.02em", color: "#0B0E14", opacity: "0.6" }}>{initials}</div>
    <h1 className="h1" style={{ marginTop: "22px", textAlign: "center" }}>{title}</h1>
    <p className="muted" style={{ margin: "8px 6px 0", textAlign: "center", fontSize: "14px", lineHeight: "21px", overflowWrap: "anywhere" }}>{body(<b style={{ color: "#FFFFFF" }}>{name}</b>, arenaLabel(c?.arena ?? "BTC"))}</p>
    {c?.kind !== "rematch" && <p className="muted" style={{ margin: "14px 6px 0", textAlign: "center", fontSize: "12px", lineHeight: "18px" }}>A challenge is open for 5 minutes and only one person can take it. Send your own and see who's brave.</p>}
    <div style={{ marginTop: "auto", paddingTop: "16px", display: "flex", flexDirection: "column", gap: "10px" }}>
      <button className="btnP" onClick={challengeBack}>CHALLENGE THEM BACK</button>
      <button className="btnS" onClick={() => go("App10", true)}>Find an opponent</button>
    </div>
  </div>
</div>
    </>
  );
}

export function App22b_ChallengeTaken() {
  return <TooLate title="Too late, it's taken" body={(name, arena) => <>Someone accepted {name}'s {arena} challenge first. It's battling right now.</>} />;
}

export function App22c_ChallengeExpired() {
  const seen = seenChallenge();
  const cancelled = seen?.state !== "expired";
  if (seen?.kind === "rematch") {
    return cancelled
      ? <TooLate title="This rematch was called off" body={(name, arena) => <>{name} took back their {arena} rematch before you got to it.</>} />
      : <TooLate title="This rematch ran out" body={(name, arena) => <>{name}'s {arena} rematch was open for 5 minutes and closed. Their stake went back.</>} />;
  }
  return cancelled ? (
    <TooLate title="This challenge was called off" body={(name, arena) => <>{name} cancelled their {arena} challenge before anyone took it.</>} />
  ) : (
    <TooLate title="This challenge expired" body={(name, arena) => <>Nobody took {name}'s {arena} challenge in time, so it closed and their stake went back.</>} />
  );
}
